import React, { cloneElement, useEffect, useMemo, useRef, useState } from 'react';
import Modal from './Modal';

import BackImage from './../../assets/images/register-samples/back.png';
import LeftImage from './../../assets/images/register-samples/left.png';
import RightImage from './../../assets/images/register-samples/right.png';
import FrontImage from './../../assets/images/register-samples/front.png';
import BackGlass from './../../assets/images/sample_images/back-glass.png';
import Glass from './../../assets/images/sample_images/glass.png';
import VehicleCardBack from './../../assets/images/sample_images/back-car-cart.png';
import Kilometr from './../../assets/images/sample_images/kilometer.png';
import Plate from './../../assets/images/sample_images/plate-top.png';
import Trunk from './../../assets/images/sample_images/trunk.png';
import Tire from './../../assets/images/sample_images/tire.png';
import ThirdImage from './../../assets/images/sample_images/third-image.jpg';
import VehicleCard from './../../assets/images/sample_images/car-cart.png';
import BackLicenseImage from './../../assets/images/sample_images/back-license.png';
import GreenCart from './../../assets/images/sample_images/green-cart.png';
import ChassisNumber from './../../assets/images/sample_images/chassis.png';
import Dashboard from './../../assets/images/sample_images/dashboard.png';
import Engine from './../../assets/images/sample_images/engine.png';
import LicenseImage from './../../assets/images/sample_images/license.png';
import PlateChassis from './../../assets/images/sample_images/plate.png';
import UnderTrunk from './../../assets/images/sample_images/under-trunk.png';
import Roof from './../../assets/images/sample_images/roof.png';
import FrontLeftCar from '../../assets/images/register-samples/left-front.png'
import BackLeftCar from '../../assets/images/register-samples/left-back.png'
import BackRightCar from '../../assets/images/register-samples/right-back.png'
import FrontRightCar from '../../assets/images/register-samples/right-front.png'

import FirstBC from './../../assets/images/sample_images/first_two_page_birth_certificate.jpg'
import SecondBC from './../../assets/images/sample_images/second_two_page_birth_certificate.jpg'
import ForthBC from './../../assets/images/sample_images/4th_two_page_birth_certificate.jpg'
import IDCard from './../../assets/images/sample_images/id_card.jpg'
import BackIDCard from './../../assets/images/sample_images/back_id_card.jpg'
import Coroukie from './../../assets/images/sample_images/croukie.png'


import { useTranslation } from 'react-i18next';
import ImageZoom from './ImageZoom';
import { history, url } from '../../utils/variables';
import { Context } from 'react-zoom-pan-pinch';
import { useSelector } from 'react-redux';
import { toast } from '../../utils/functions';
import FrontCar from '../../assets/images/car-frames/front50.png';
import BackCar from '../../assets/images/car-frames/back50.png';
import LeftSideCar from '../../assets/images/car-frames/left-side50.png';
import RightSideCar from '../../assets/images/car-frames/right-side50.png';
import Frame from '../../assets/images/car-frames/final.png'

import LicenseCardPH from '../../assets/images/AddImagePlaceholder/add-front-license.png'
import BackCardPH from '../../assets/images/AddImagePlaceholder/add-back-license.png'
import VehicleCardPH from '../../assets/images/AddImagePlaceholder/add-front-vehicle-card.png'
import ThirdInsurancePH from '../../assets/images/AddImagePlaceholder/add-third-insurance.png'
import BodyInsurancePH from '../../assets/images/AddImagePlaceholder/add-body-insurance.png'
import FrontCarPH from '../../assets/images/AddImagePlaceholder/add-front-car.png'
import BackCarPH from '../../assets/images/AddImagePlaceholder/add-back-car.png'
import RightCarPH from '../../assets/images/AddImagePlaceholder/add-right-car.png'
import LeftCarPH from '../../assets/images/AddImagePlaceholder/add-left-car.png'
import FirstTwoPagePH from '../../assets/images/AddImagePlaceholder/add-firstpage-birth-certificate.png'
import SecondTwoPagePH from '../../assets/images/AddImagePlaceholder/add-secondpage-birth-certificate.png'
import LastDesgreePH from '../../assets/images/AddImagePlaceholder/add-degree.png'
import ExpertSign from '../../assets/images/AddImagePlaceholder/add-signature.png'
import ChassisPH from '../../assets/images/AddImagePlaceholder/add-chassies.png'
import FrontLeftPH from '../../assets/images/AddImagePlaceholder/front-left.png'
import BackLeftPH from '../../assets/images/AddImagePlaceholder/back-left.png'
import FrontRightPH from '../../assets/images/AddImagePlaceholder/front-right.png'
import BackRightPH from '../../assets/images/AddImagePlaceholder/back-right.png'

import Cropper from 'react-easy-crop'


export default function ImagePickerModal({renderBtn, disableGallery, disableCamera, upload ,label = '' , imageUid,croppable = false}) {

    const videoRef = useRef(null);
    const [notif,setNotif] = useState(true);
    const { user } = useSelector(store => store);
    const [camera, setCamera] = useState(false);

    const [open, setOpen] = useState(false);
    const [content, setContent] = useState('picker');
    const [cropperModal,setCropperModal] = useState(false);
    const [imageToCrop,setImageToCrop] = useState();
    const [zoom,setZoom] = useState(1)
    const [crop,setCrop] = useState({ x: 0, y: 0 })
    const [croppedAreaPixels, setCroppedAreaPixels] = useState(null)
    const { t } = useTranslation();
    function getImage(dataUrl) {
        return new Promise((resolve, reject) => {
            const image = new Image();
            image.src = dataUrl;
            image.onload = () => {
                resolve(image);
            };
            image.onerror = (el, err) => {
                reject(err.error);
            };
        });
    }
    function openCamera () {
        try {
            navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} })
            .then(async (stream)=>{
                stream && setCamera(true)
                // setTimeout(()=>videoRef.current.srcObject = stream,1000)
                // setTimeout(()=>notif.current.style.display = 'none',3000)
            })
            .catch(()=>{
                toast('لطفا برای دسترسی به دوربین تنظیمات خود را مجددا بررسی کنید','error');
            })
        } catch (error) {
            toast('دسترسی به دوربین خود را فعال کنید','error');
            // console.error('Error accessing camera:', error);
        }
      }
      useEffect(() => {
        let close  
        const startCamera = async () => {
          try {
            const stream = await navigator.mediaDevices.getUserMedia({ video: {facingMode:"environment"} });
            if (videoRef.current) {
              videoRef.current.srcObject = stream;
              close = setTimeout(()=>setNotif(false),3000)
            //   close = setTimeout(()=>notif.current.style.display = 'none',3000)
            }
          } catch (error) {
            console.error("Error accessing the camera: ", error);
          }
        };

        camera && startCamera();
        return () => {
          if (videoRef.current && videoRef.current.srcObject) {
            const stream = videoRef.current.srcObject;
            const tracks = stream.getTracks();
            tracks.forEach(track => track.stop());
            videoRef.current.srcObject = null;
            clearTimeout(close)
          }
        };
      }, [camera]);
      async function takePicture() {
        setContent('loader');
        const image = videoRef.current;
        // if(croppable){
        //     setImageToCrop(image)
        //     setCropperModal(true)
        //     setContent('picker');
        //     return;
        // }
        
        if (image) {
            const oldWidth = image.videoWidth;
            const oldHeight = image.videoHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            // if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            // }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                upload(blob, () => {
                    setCamera(false);
                    setOpen(false);
                    setTimeout(() => setContent('picker'), 500);
                });
            },'image/jpeg', 0.7);
        }
      }
    async function submitImage(e) {
        const [file] = e.target?.files || [];
        setContent('loader');
        if (file) {
            const url = window.URL.createObjectURL(file);
            const image = await getImage(url);
            const oldWidth = image.naturalWidth;
            const oldHeight = image.naturalHeight;

            const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
            const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

            let newWidth = oldWidth;
            let newHeight = oldHeight;

            if (currentRes > 1080) {
                const newSize = longestDimension === 'width'
                    ? Math.floor(oldHeight / oldWidth * 1080)
                    : Math.floor(oldWidth / oldHeight * 1080);
                newWidth = longestDimension === 'width' ? 1080 : newSize;
                newHeight = longestDimension === 'height' ? 1080 : newSize;
            }

            const canvas = document.createElement('canvas');
            canvas.width = newWidth;
            canvas.height = newHeight;

            const ctx = canvas.getContext('2d');
            ctx.drawImage(image, 0, 0, newWidth, newHeight);
            canvas.toBlob((blob) => {
                upload(blob, () => {
                    setOpen(false);
                    setTimeout(() => setContent('picker'), 500);
                });
            },'image/jpeg', 0.7);
        }
    }
    ///
    const sampleImages = [
            {label : 'license_image' , src: LicenseImage , title: t('License')},
            {label : 'back_license_image' , src: BackLicenseImage, title: t('License back')},
            {label : 'front_image' , src: FrontImage, title: t('Front vehicle')},
            {label : 'back_image' , src: BackImage, title: t('Back vehicle')},
            {label : 'left_image' , src: LeftImage, title: t('Left side vehicle')},
            {label : 'right_image' , src: RightImage, title: t('Right side vehicle')},
            {label : 'vehicle_card_image' , src: VehicleCard, title: t('Vehicle card')},
            {label : 'vehicle_card_back_image' , src: VehicleCardBack, title: t('Vehicle card back')},
            {label : 'third_image' , src: ThirdImage, title: t('Insurance')},
            {label : 'body_image' , src: ThirdImage, title: t('Insurance')},
            {label : 'chassis_number' , src: ChassisNumber, title: t('Engraved chassis number')},
            {label : 'expert_plate' , src: Plate, title: t('Plate')},
            {label : 'green-card' , src: GreenCart, title: t('Green card')},
            {label : 'front_glass' , src: Glass, title: t('Front glass')},
            {label : 'back_glass' , src: BackGlass, title: t('Back glass')},
            {label : 'dashboard' , src: Dashboard, title: t('Dashboard')},
            {label : 'motor' , src: Engine, title: t('Motor image')},
            {label : 'kilometer' , src: Kilometr, title:  t('Kilometr image')},
            {label : 'car-ceiling' , src: Roof, title: t('Car ceiling')},
            {label : 'tire' , src: Tire, title: t('Tire')},
            {label : 'trunk' , src: Trunk, title: t('Trunk')},
            {label : 'under_trunk' , src: UnderTrunk, title: t('Under trunk')},
            {label : 'plate_chassis' , src: PlateChassis, title: t('Plate chassis')},

            {label : 'first_two_page_birth_certificate' , src: FirstBC, title: t('First Two Page Birth Certificate')},
            {label : 'second_two_page_birth_certificate' , src: SecondBC, title: t('Second Two Page Birth Certificate')},
            // {label : 'third_two_page_birth_certificate' , src: ThirdBC, title: t('Third Two Page Birth Certificate')},
            {label : '4th_two_page_birth_certificate' , src: ForthBC, title: t('4th Two Page Birth Certificate')},
            {label : 'expert_id_card' , src: IDCard, title: t('ID card')},
            {label : 'expert_back_id_card' , src: BackIDCard, title: t('Back ID card')},
            // {label : 'expert_duty_end_card' , src: DutyEndCard, title: t('Duty end card')},
            {label:'front_left_image',title:t('Front Left vehicle'),src: FrontLeftCar},
            {label:'back_left_image',title:t('Back Left vehicle'),src: BackLeftCar},
            {label:'back_right_image',title:t('Back Right vehicle'),src: BackRightCar},
            {label:'front_right_image',title:t('Front Right vehicle'),src: FrontRightCar},
            {label:'id_card',src: IDCard, title: t('ID card')},
            {label:'croukie_image',src: Coroukie, title: t('Police Report')},
    ]
    const carSides = [ {label :'front_image', image : FrontCar} , {label : 'back_image', image : BackCar} , {label : 'left_image', image : LeftSideCar} , {label : 'right_image', image : RightSideCar}]
    const [showImage , setShowImage] = useState(null);
    const imagePlaceholders = {
        'license_image' : LicenseCardPH,
        'back_license_image' : BackCardPH,
        'vehicle_card_image' : VehicleCardPH,
        'vehicle_card_back_image' : BackCardPH,
        'third_image' : ThirdInsurancePH,
        'body_image' : BodyInsurancePH,
        'front_image' : FrontCarPH,
        'back_image' : BackCarPH,
        'right_image' : RightCarPH,
        'left_image' : LeftCarPH,
        'chassis_number' : ChassisPH,
        'first_two_page_birth_certificate' : FirstTwoPagePH,
        'second_two_page_birth_certificate' : SecondTwoPagePH,
        'third_two_page_birth_certificate' : SecondTwoPagePH,
        '4th_two_page_birth_certificate' : SecondTwoPagePH,
        'expert_id_card' : LicenseCardPH,
        'expert_back_id_card': BackCardPH,
        'expert_duty_end_card': LicenseCardPH,
        'expert_last_degree': LastDesgreePH,
        'expert_sign' : ExpertSign,
        'complement_img' : BackCardPH,
        'id_card' : LicenseCardPH,
        'front_left_image' : FrontLeftPH,
        'back_left_image' : BackLeftPH,
        'back_right_image' : BackRightPH,
        'front_right_image' : FrontRightPH,
        'croukie_image':VehicleCardPH,
        //register images
        'expert_plate':BackCarPH,
        'green-card':VehicleCardPH,
        'front_glass':FrontCarPH,
        'motor':ChassisPH,
        'plate_chassis':ChassisPH,
        'kilometer':FrontCarPH,
        'dashboard':FrontCarPH,
        'car-ceiling':FrontCarPH,
        'trunk':BackCarPH,
        'under_trunk':ChassisPH,
        'back_glass':BackCarPH,
        'tire':RightCarPH


    };
    const DefaultElement = useMemo(()=>{
        return(
            <div className='upload-icon-parent'>
                <img className='img-placeholder' src={imagePlaceholders[label]}/>
            </div>
        )

    },[renderBtn])
    // const onCropComplete = (croppedArea, croppedAreaPixels) => {
    //     setCroppedAreaPixels(croppedAreaPixels)
    //     console.log(croppedAreaPixels.width,croppedAreaPixels.height)
    //   }
    async function submitCropImage(e){
        const [file] = e.target?.files || [];
        if (file) {
            const url = window.URL.createObjectURL(file);
            setImageToCrop(url)
            setCropperModal(true)
        }
    }
    const cropImage = async()=>{
        setCropperModal(false)
        const image = await getImage(imageToCrop);
        const oldWidth = croppedAreaPixels.width;
        const oldHeight = croppedAreaPixels.height;

        const longestDimension = oldWidth > oldHeight ? 'width' : 'height';
        const currentRes = longestDimension === 'width' ? oldWidth : oldHeight;

        let newWidth = oldWidth;
        let newHeight = oldHeight;

        if (currentRes > 1080) {
            const newSize = longestDimension === 'width'
                ? Math.floor(oldHeight / oldWidth * 1080)
                : Math.floor(oldWidth / oldHeight * 1080);
            newWidth = longestDimension === 'width' ? 1080 : newSize;
            newHeight = longestDimension === 'height' ? 1080 : newSize;
        }

        const canvas = document.createElement('canvas');
        canvas.width = newWidth;
        canvas.height = newHeight;

        const ctx = canvas.getContext('2d');
        // ctx.drawImage(image, 0, 0, newWidth, newHeight);
        ctx.drawImage(
            image,
            croppedAreaPixels.x,
            croppedAreaPixels.y,
            croppedAreaPixels.width,
            croppedAreaPixels.height,
            0,
            0,
            croppedAreaPixels.width,
            croppedAreaPixels.height
          )
        canvas.toBlob((blob) => {
            upload(blob, () => {
                setOpen(false);
                // setCamera(false);
                setTimeout(() => setContent('picker'), 500);
            });
        },'image/jpeg', 0.7);
    }
    function isDesktopDevice() {
        const userAgent = navigator.userAgent || navigator.vendor || window.opera;
        const isMobile = /android|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows phone/i.test(userAgent);
        const hasDesktopFeatures =
        // Check for pointer device (mouse/trackpad)
        navigator.maxTouchPoints <= 0 ||
        // Check for ability to open new windows/tabs
        !('onorientationchange' in window) ||
        // Check for keyboard events
        'keyboard' in navigator;

        // Check viewport dimensions
        const viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
        const viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
        const isLargeViewport = viewportWidth >= 1024 && viewportHeight >= 768;

        // Determine if it's a desktop device
        return !isMobile && (hasDesktopFeatures || isLargeViewport);
        // return /android|ipad|iphone|ipod|blackberry|iemobile|opera mini|windows phone/i.test(userAgent);
        // return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent);
    }
    return (
        <>
            <>
                {
                    cloneElement(renderBtn !== 'default' ? renderBtn : DefaultElement, {
                        onClick: () => setOpen(true)
                    })
                }
            </>
            
            <Modal visible={open}>
                {
                    content === 'picker' &&
                    <div className='modal-content d-flex flex-column align-items-center rtl'>
                        { (label && imageUid) &&
                            <div className='d-flex flex-column justify-center sample-image m10' style={{ minWidth : '300px'}}>
                               
                                {
                                    // <>
                                    // {!isSampleImage && <div className='sample-alert' onClick={()=> setIsSampleImage(true)}><i className='fas fa-info mr5 ml5'/>  جهت مشاهده عکس نمونه اینجا کلیک کنید</div>}
                                    // {
                                    //     isSampleImage ?

                                    // <div className='d-flex flex-column'>                                   
                                    //     {sampleImages.map(itm=> itm.label === label && 
                                    //     <div className='d-flex flex-column' key={label}>
                                    //     <h5 className='p5 mb15 border-bottom text-center'> {t('Sample image')} {itm.title} </h5>
                                    //     <img style={{width: '90%',margin: 'auto'}} src={itm.src} alt="sample"/>
                                    //     </div>
                                    //     )}
                                    //     <button className='btn btn-red btn-block btn-circle mt10' onClick={()=> setIsSampleImage(false)}>بستن </button>
                                    // </div>
                                    // :
                                    //  <div className='d-flex flex-column'>
                                    //     <img style={{width: '90%',margin: 'auto'}} src={`${url}/files?uid=${imageUid?.uid}&width=150&height=150`} alt="img" 
                                    //         onClick={()=> setShowImage(imageUid.uid)}
                                    //     />
                                    // </div>
                                    // }
                                    
                                    // </>

                                    <>
                                                                                    
                                            {/* {sampleImages.map(itm => itm.label === label &&
                                                <div className='d-flex flex-column' key={label}>
                                                    <h5 className='p5 mb15 border-bottom text-center'> {t('Sample image')} {itm.title} </h5>
                                                    <img style={{ width: '80%', margin: 'auto' }} src={itm.src} alt="sample" />
                                                </div>
                                            )} */}
                                                                       
                                        <div className='d-flex align-items-center mt10 p10 space-between uploaded-image' onClick={() => setShowImage(imageUid.uid)}>
                                                <span className='p5 text-center uploaded-text'><i className='fas fa-check p5 m5'/> عکس بارگذاری شده </span>
                                                <img src={`${url}/files?uid=${imageUid?.uid}&width=80&height=80`} alt="img"/>
                                            </div>                                               
                                       
                                    </>
                                }
                                
                            </div>
                }
                        
                            {
                                (label && !imageUid)
                                &&
                            <div className='d-flex flex-column sample-image m20'>
                                
                                    {sampleImages.map(itm=> itm.label === label && 
                                    <>
                                    
                                    <h5 className='p5 mb15 border-bottom text-center' key={label}> {t('Sample image')} {itm.title} </h5>
                                    <img style={{width: '90%',margin: 'auto'}} src={itm.src} alt="sample"/>
                                    
                                    </>
                                    )}
                            </div>
                                // :
                                // <img src={DefaultImage} alt="sample"/>
                            }
                        <>
                        {disableGallery && !disableCamera && isDesktopDevice() &&
                        <p style={{color:'white'}}>
                            امکان بارگذاری تصویر از گالری وجود ندارد
                        </p>}
                        <div className='d-flex justify-center m10' style={{width: '250px',gap:'5px'}}>
                          {
                            !disableGallery && user.id !== 333 &&
                            <label className='flex1' style={{backgroundColor: '#0dd6a9',borderRadius: '5px',color:'white'}}>
                                <div className='text-center p10'>
                                    {/* <i className="fas fa-image p5" style={{fontSize: '18px'}}></i>  */}
                                    گالری
                                </div>
                                <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                            </label>
                        }
                        {
                            !disableGallery && user.id === 333 &&
                            <label className='flex1' style={{backgroundColor: '#0dd6a9',borderRadius: '5px',color:'white'}}>
                                <div className='text-center p10'>
                                    {/* <i className="fas fa-image p5" style={{fontSize: '18px'}}></i> */}
                                    گالری
                                </div>
                                <input type='file' accept='image/*' style={{display: 'none'}} onChange={(e)=>croppable ? submitCropImage(e) :submitImage(e)}/>
                            </label>
                        }
                        {
                            !disableCamera && user.id === 333 && !isDesktopDevice() &&
                                <label className='flex1' style={{backgroundColor : '#1dceff',borderRadius: '5px',color:'white'}} onClick={openCamera}>
                                    <div className='p10 text-center'>
                                        {/* <i className="fas fa-camera p5" style={{fontSize: '18px'}}></i> */}
                                        دوربین
                                    </div>
                                    {/* <input type='file' accept='image/*' capture='environment' style={{display: 'none'}} onChange={submitImage}/> */}
                                </label>
                        }
                        {
                            !disableCamera && user.id !== 333 && !isDesktopDevice() &&
                                <label className='flex1' style={{backgroundColor : '#1dceff',borderRadius: '5px',color:'white'}}>
                                    <div className='p10 text-center'>
                                        {/* <i className="fas fa-camera p5" style={{fontSize: '18px'}}></i> */}
                                        دوربین
                                    </div>
                                    <input type='file' accept='image/*' capture='environment' style={{display: 'none'}} onChange={submitImage}/>
                                </label>
                            
                        }
                        <label className='flex1'>
                            <div className='p10 text-center' style={{backgroundColor: '#ff3b74',borderRadius: '5px',color:'white'}} onClick={() => setOpen(false)}>
                                {/* <i className='fas fa-times p5' style={{fontSize: '18px'}}/> */}
                                انصراف
                            </div> 
                        </label>
                        </div>
                        </>
                    
                     {/* {
                            !disableGallery &&
                            <label>
                                <div className='modalBtn'>آپلود از گالری</div>
                                <input type='file' accept='image/*' style={{display: 'none'}} onChange={submitImage}/>
                            </label>
                        }
                        {
                            !disableCamera &&
                            <label>
                                <div className='modalBtn'>آپلود از دوربین گوشی</div>
                                <input type='file' accept='image/*' capture='environment' style={{display: 'none'}}
                                       onChange={submitImage}/>
                            </label>
                        }
                        <div className='modalBtn' style={{borderBottom: 0}} onClick={() => setOpen(false)}>انصراف</div>  */}
                    </div>
                }
                {
                    content === 'loader' &&
                    <div className='loader-modal'>
                        <p>{t('Uploading image')}</p>
                        <i className='fas fa-spinner fa-spin'/>
                    </div>
                }
            </Modal>
            <Modal visible={showImage}>
                <div className='image-modal'>
                    <i className='fas fa-times'
                       onClick={() => setShowImage(null)}
                    />
                    <ImageZoom imgUid={showImage}/>
                </div>
            </Modal>
            <Modal visible={camera}>
            <div className='screen-camera'>
                <video ref={videoRef} autoPlay playsInline muted style={{ height: '100%'}}></video>
                {/* {label && carSides.map((item)=> item.label === label &&
                <> */}
                    {notif &&
                    <div className='tuturial-notif'> 
                        <i className='fas fa-times' onClick={()=> setNotif(false)}/>.تلاش کنید تصویر مورد نظر را در کادر  زیر قرار دهید 
                    </div>
                    }
                    {/* <img className='upper-image' src={item.image} />                 
                </>
                 )}  */}
                 <img className='upper-image' src={Frame} /> 
                {sampleImages.map(itm => itm.label === label &&
                        <div key={label}>
                            <h5 className=' border-bottom image-title'> {itm.title} </h5>
                            <img className='sample-img' src={itm.src} alt="sample" />
                        </div>
                    )}

                <div className='d-flex justify-center align-items-center navigate-btns'>
                    <button className='capture-btn' onClick={takePicture}/>
                    <i className='fas fa-times mb25 mr30 close-btn' onClick={()=>setCamera(false)} />
                </div>
            </div>
            </Modal> 

            <Modal visible={cropperModal}>
                <div className='cropper-image'>
                    <Cropper
                        image={imageToCrop}
                        crop={crop}
                        zoom={zoom}
                        aspect={1}
                        onCropChange={setCrop}
                        onCropComplete={(croppedArea, croppedAreaPixels)=>setCroppedAreaPixels(croppedAreaPixels)}
                        onZoomChange={setZoom}
                        />
                    <button className='crop-btn btn btn-circle' onClick={cropImage}>
                        برش
                    </button>
                    <span className='close-btn' onClick={()=>setCropperModal(false)}>
                        <i className='fas fa-times'/>
                    </span>
                </div>
            </Modal>
        </>
    );
}
